document.addEventListener('click', function (e) {
  const opener = e.target.closest('.product__media-opener');
  if (!opener) return;

  e.preventDefault();
  const modalSel = opener.getAttribute('data-modal');
  const modal = document.querySelector(modalSel);
  if (modal && typeof modal.show === 'function') {
    modal.show(opener); // passes opener so ProductModal can read data-media-id
  }
});

// keyboard accessibility
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  const opener = document.activeElement?.closest?.('.product__media-opener');
  if (!opener) return;

  e.preventDefault();
  const modalSel = opener.getAttribute('data-modal');
  const modal = document.querySelector(modalSel);
  if (modal && typeof modal.show === 'function') {
    modal.show(opener);
  }
});